// TODO : display errors on this page

import { orderBy } from "firebase/firestore";
import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router";

import {
    useDroneConfigCollection,
    usePayloadCollection,
} from "../../api/firestoreWrappers.generated.jsx";
import {
    CorvusList,
    CorvusListItem,
    CorvusListItemText,
} from "../../components/CorvusList";
import Layout, { Title } from "../../components/Layout/Layout";
import urls from "../../urls.jsx";

export default function PayloadListPage() {
    const [payloads] = usePayloadCollection([orderBy("name", "asc")]);
    const [droneConfigs] = useDroneConfigCollection([]);

    const droneIdsByPayload = React.useMemo(() => {
        return droneConfigs.reduce((map, { id, payloadId }) => {
            if (!map[payloadId]) map[payloadId] = [];
            map[payloadId].push(id);
            return map;
        }, {});
    }, [droneConfigs]);

    return (
        <Layout>
            <title>Payloads | MyCorvus</title>
            <Card>
                <Title title="Payloads" />
                <CorvusList>
                    {payloads.map((payload) => (
                        <CorvusListItem
                            className="p-0"
                            key={payload.id}
                            as={Link}
                            to={urls.payloadSettings(payload.id)}
                        >
                            <CorvusListItemText>
                                {payload.name} [
                                {(droneIdsByPayload[payload.id] || []).join(
                                    ", ",
                                )}
                                ]
                            </CorvusListItemText>
                        </CorvusListItem>
                    ))}
                </CorvusList>
            </Card>
        </Layout>
    );
}
